import api from './utilBackoffice';

const controller = 'Operador';
const url = process.env.VUE_APP_ROOT_API + controller;
export default Object.assign({}, api.GetCrud(controller, null), {
  Listar: dto => api.Axios.GetParams(url, dto),
  ValidaEmail: dto => api.Axios.GetParams(url + '/ValidaEmail', dto),
  Create: dto => api.Axios.Post(url, dto),
  Update: (id, dto) => api.Axios.Put(url, id, dto)
});
